export default "__VITE_ASSET__CjSkqU6P__"